import { ConfirmService } from '@mmx/shared'
import { Observable } from 'rxjs'
import { take, takeUntil } from 'rxjs/operators'

export function escapeTraceHtml(text: string): string {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function openJsonTraceDialog(
  confirmService: ConfirmService,
  title: string,
  payload: unknown,
  prefixHtml = '',
  destroy$?: Observable<void>,
): void {
  const json = escapeTraceHtml(JSON.stringify(payload, null, 2) ?? 'null')
  const message = `<strong>${escapeTraceHtml(title)}</strong><br>${prefixHtml}<pre>${json}</pre>`
  const confirm$ = confirmService.confirm({
    message,
    html: true,
    hideNoButton: true,
    yesBtnLabel: 'common.close',
    width: '1000px',
  })

  const piped$ = destroy$
    ? confirm$.pipe(take(1), takeUntil(destroy$))
    : confirm$.pipe(take(1))

  piped$.subscribe()
}

export function openTraceMessageDialog(
  confirmService: ConfirmService,
  message: string,
  destroy$?: Observable<void>,
): void {
  const confirm$ = confirmService.confirm({
    message: escapeTraceHtml(message),
    html: false,
    hideNoButton: true,
    yesBtnLabel: 'common.close',
    width: '600px',
  })

  const piped$ = destroy$
    ? confirm$.pipe(take(1), takeUntil(destroy$))
    : confirm$.pipe(take(1))

  piped$.subscribe()
}
